import React, { useState, useEffect, useMemo } from 'react';
import {
  Button,
  Typography,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { Formik } from 'formik';
import {
  ButtonFlex,
  FormRow,
  StyledForm,
  RowItem,
} from '../../../styles/styles';
import SimpleSelect from '../../../util/SimpleSelect';
import { useRootStore } from '../../../../stores/BridgeProvider';
import { MenuList, filterOptions } from '../../../util/ReactSelectOverrides';
import {
  CustomCreatableSelect,
  CustomSelect,
} from '../../../util/CustomCreatableSelect';
import { safeEval } from '../../../util/UtilFunctions';

const FieldModal = ({
  handleClose,
  setSelectedField,
  selectedField,
  setValueForParent,
  items,
  updateTemplate,
}) => {
  const { dataStore } = useRootStore();
  const transactionCategories = dataStore.validTransactionCategoryArray;
  const { name, label, fieldType } = selectedField;
  return (
    <div style={{ minWidth: 300 }}>
      <Typography variant="h4" gutterBottom>
        Set {label} Value
      </Typography>
      <Formik
        initialValues={{
          [name]: selectedField.curVal,
        }}
        onSubmit={async (values, { resetForm, setSubmitting }) => {
          setValueForParent(name, values[name]);
          updateTemplate();
          handleClose();
        }}
        render={formikProps => {
          const {
            handleSubmit,
            isSubmitting,
            isValid,
            dirty,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
          } = formikProps;

          const filteredItems = items.filter(item => item.type === fieldType);

          const addVariableValue = newVar => {
            const curVal = values[selectedField.name];

            const newString = `${curVal}${newVar}`;
            setFieldValue(name, newString);
          };

          const replaceValue = newString => {
            setFieldValue(name, newString);
          };

          const curVal = values[selectedField.name];

          return (
            <StyledForm onSubmit={handleSubmit}>
              {fieldType === 'tranCategory' && (
                <FormRow>
                  <SimpleSelect
                    label="Select Transaction Category From Organization"
                    handleChange={e => replaceValue(e.target.value)}
                    value={values[selectedField.name]}
                    name="CategoryId"
                  >
                    <MenuItem value={null}>
                      <em>None</em>
                    </MenuItem>
                    {transactionCategories.map(({ TranCategoryId, Code }) => (
                      <MenuItem key={TranCategoryId} value={TranCategoryId}>
                        {Code}
                      </MenuItem>
                    ))}
                  </SimpleSelect>
                </FormRow>
              )}
              {['agent', 'contact'].includes(fieldType) &&
                (() => {
                  // const contactObj = dataStore.getContactFromId(curVal) || {};
                  const contactObj = dataStore.getContactFromName(curVal) || {};

                  return (
                    <FormRow>
                      <RowItem>
                        <div style={{ width: '100%', zIndex: 1002 }}>
                          <CustomSelect
                            isSearchable
                            isClearable
                            placeholder="Contacts"
                            components={{ MenuList }}
                            options={dataStore.contacts}
                            getOptionLabel={option => option.Name}
                            getOptionValue={option => option.ContactId}
                            // value={curVal}
                            value={contactObj}
                            filterOption={filterOptions}
                            onChange={val => {
                              // setFieldValue('account', val);
                              // replaceValue(safeEval(() => val.ContactId));
                              replaceValue(safeEval(() => val.Name));
                            }}
                          />
                        </div>
                      </RowItem>
                    </FormRow>
                  );
                })()}
              <TextField
                value={curVal || ''}
                margin="normal"
                onChange={handleChange}
                onBlur={handleBlur}
                variant="outlined"
                fullWidth
                {...selectedField}
              />
              <SimpleSelect
                // handleChange={handleChange}
                handleChange={e => addVariableValue(e.target.value)}
                // value={values[selectedField.name]}
                // name="type"
                value=""
                label="Add variable to formula"
                containerStyle={{ width: '100%' }}
                // {...selectedField}
              >
                {filteredItems.map(({ name: itemName, displayName }) => (
                  <MenuItem key={itemName} value={`$${itemName}`}>
                    {displayName} Field
                  </MenuItem>
                ))}
                {fieldType === 'date' && (
                  <MenuItem key="today" value="%CurrentDate">
                    Current Date
                  </MenuItem>
                )}
                {['agent', 'contact'].includes(fieldType) && (
                  <MenuItem key="curUser" value="%CurrentUser">
                    Current User
                  </MenuItem>
                )}
              </SimpleSelect>

              <ButtonFlex>
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  size="large"
                  disabled={!dirty || isSubmitting}
                  style={{
                    margin: '5px',
                  }}
                >
                  Submit
                </Button>
              </ButtonFlex>
            </StyledForm>
          );
        }}
      />
    </div>
  );
};

export default FieldModal;
